export const translation = {
  nav: {
    home: 'Home',
    products: 'Produkte',
    company: 'Unternehmen',
    downloads: 'Download',
    contact: 'Kontakt',
    news: 'News',
    language: 'Sprache',
    menu: 'Menü',
  },
  hero: {
    title: 'Fertigungsmaschinen mit modernster Technologie',
    subtitle: '"MADE IN GERMANY"!',
    description: 'Wir sind ein weltweit operierendes Familienunternehmen und ein führender Hersteller von Anspitzmaschinen, Richtmaschinen, Ablaufhaspeln, Vereinzelungen und Zuführung für Anspitzmaschinen.',
    description2: 'Von der Konstruktion bis zur Inbetriebnahme bieten wir Kunden in allen Teilen der Welt High-Tech-Produkte für die Bearbeitung von Draht, Stangen und Rohren.',
  },
  contactSection: {
    title: 'Ihr Kontakt zu uns:',
    phone: 'Tel.:',
    phoneNumber: '+49 (0) 2351 / 5 21 33',
    email: 'Oder per Mail:',
    emailAddress: 'sales@bock-mf.de',
  },
  products: {
    title: 'Unsere Produkte',
    subtitle: 'Hochtechnologische Maschinen für die Draht-, Stangen- und Rohrbearbeitung',
    pointingMachines: 'Anspitzmaschinen',
    pointingMachinesDesc: 'Präzisionsmaschinen für Anspitzvorgänge',
    straighteningMachines: 'Richtmaschinen',
    straighteningMachinesDesc: 'Hochwertige Richtanlagen für verschiedene Materialien',
    wirePayoffs: 'Ablaufhaspeln',
    wirePayoffsDesc: 'Effiziente Drahtführungs- und Zuführsysteme',
    deCoiling: 'Vereinzelungen & Zuführung',
    deCoilingDesc: 'Automatisierte Vereinzelungen und Zuführeinheiten für Anspitzmaschinen',
  },
  about: {
    title: 'Über Uns',
    subtitle: 'Ein Familienunternehmen mit weltweiter Präsenz',
    description: 'Die Maschinenfabrik Bock GmbH & Co. KG ist heute ein weltweit operierendes Familienunternehmen mit Vertretungen in vielen Ländern, das sich zu einem führenden Hersteller von Anspitzmaschinen mit unterschiedlichen Technologien entwickelt hat.',
    quality: 'Know-how',
    qualityDesc: 'Unser gesamtes Team ist hochqualifiziert ausgebildet. Der Einsatz modernster Maschinen und CAD-Technologien garantiert Ihnen Produktionsverfahren auf höchstem Niveau.',
    innovation: 'Individualität',
    innovationDesc: 'Wir bauen genau die Maschinen, die Sie benötigen. Individuelle Lösungen sind unsere Spezialität.',
    worldwide: 'Persönliche Beratung',
    worldwideDesc: 'Unser Erfolg ist das Ergebnis von Persönlichkeit, Menschlichkeit und technischem Gespür.',
  },
  footer: {
    imprint: 'Impressum',
    sitemap: 'Sitemap',
    contact: 'Kontakt',
    privacy: 'Datenschutz',
    privacySettings: 'Datenschutzeinstellungen',
    print: 'Drucken',
    copyright: 'Maschinenfabrik Bock GmbH & Co. KG',
    youtube: 'YouTube',
    madeInGermany: 'Made in Germany',
  },
  contactPage: {
    title: 'Kontakt',
    phone: 'Telefon',
    fax: 'Fax',
    faxNumber: '+49 (0) 2351 / 5 26 70',
    email: 'E-Mail',
    address: 'Adresse',
    addressLine1: 'Maschinenfabrik Bock GmbH & Co. KG',
    addressLine2: 'Altenaer Straße 170',
    addressLine3: 'D-58513 Lüdenscheid, Deutschland',
    managingDirector: 'Dipl.-Ing. Karsten Bock - Geschäftsführer',
    administration: 'Jutta Kordt-Bock - Verwaltung',
    team: 'Ansprechpartner',
  },
  productsPage: {
    title: 'Produkte',
    subtitle: 'Maschinen für die Draht-, Stangen- und Rohrbearbeitung',
    pointingWire: 'Anspitzmaschinen für Draht',
    pointingWireDesc: 'Unsere Anspitzmaschinen für Draht sind für höchste Präzision und Effizienz ausgelegt.',
    pointingBars: 'Anspitzmaschinen für Stangen',
    pointingBarsDesc: 'Robuste Anspitzmaschinen für Stangen und Rohre.',
    straightening: 'Richtmaschinen',
    straighteningDesc: 'Hochleistungs-Richtmaschinen für Draht, Stangen und Rohre.',
    payoffs: 'Ablaufhaspeln & Vereinzelungen',
    payoffsDesc: 'Automatisierte Ablaufhaspeln und Vereinzelungen.',
    feeding: 'Zuführeinheiten',
    feedingDesc: 'Präzise Zuführeinheiten für die automatische Materialversorgung.',
  },
  newsPage: {
    title: 'News',
    subtitle: 'Immer aktuell! Wir bieten Ihnen interessante Informationen aus dem Markt und zu technischen Entwicklungen aus unserem Unternehmen.',
    readMore: 'Weiterlesen',
  },
  downloadsPage: {
    title: 'Download',
    subtitle: 'Prospekte, technische Dokumentationen und Kataloge',
    catalogs: 'Produktkataloge',
    technicalDocs: 'Technische Dokumentation',
    certificates: 'Zertifikate',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    description: 'Die gesuchte Seite existiert nicht.',
    backHome: 'Zurück zur Startseite',
  },
  common: {
    learnMore: 'Mehr erfahren',
    viewAll: 'Alle ansehen',
    madeInGermany: 'Made in Germany',
  },
  impressumPage: {
    title: 'Impressum',
  },
  datenschutzPage: {
    title: 'Datenschutzerklärung',
  },
};

export default translation;